// extracted by mini-css-extract-plugin
export default {"public":"Public_public__mKQTB"};